/**
 * @author Harshitha.k
 * @description 
 */

import { Input, Tag } from 'antd';
import React, { useState, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';

const ColorInputWidget = (props) => {
  const [inputTagVisible, setInputTagVisible] = useState(false);
  // const [tagList, setTagList] = useState([]);
  // const [graphTypeProps, setGraphTypeProps] = useState(props.graphTypeProps || {});
  const [value, setValue] = useState(props.value || []);

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value || []);
    }
  }, [props.value]);

  const handleTagClick = () => {
    setInputTagVisible(!inputTagVisible);
  };

  const handleKeyPress = (e) => {
    const newValue = [...value, e.target.value];
    setInputTagVisible(!inputTagVisible);
    props.addedTagList(newValue);
  };

  const handleTagClose = (index) => {
    const newValue = [...value];
    newValue.splice(index, 1);
    setValue(newValue);
    setInputTagVisible(!inputTagVisible);
    props.addedTagList(newValue);
  };

  return (
    <div>
      <Tag
        onClick={handleTagClick}
        style={{  borderStyle: 'dashed' }}
        value={value}
      >
        <PlusOutlined /> New Tag
      </Tag>

      {inputTagVisible && (
        <Input
          type="text"
          onPressEnter={handleKeyPress}
        />
      )}
      {value &&
        Array.isArray(value) &&
        value.map((tags, index) => {
          const isLongTag = tags.length > 20;
          const tagElem = (
            <Tag
              color={tags}
              key={tags}
              closable={true}
              onClose={() => handleTagClose(index)}
            >
              {isLongTag ? `${tags.slice(0, 20)}...` : tags}
            </Tag>
          );
          return isLongTag ? tagElem : tagElem;
        })}
    </div>
  );
};

export default ColorInputWidget;